import { useQuery } from "react-query";
import { fetchSmsTemplates, SMS_QUERY_KEYS } from "@/services/sms";
/** Query hook listing a workspace's SMS templates for the composer. */
export function useSmsTemplates(workspaceId) {
  var enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return useQuery(SMS_QUERY_KEYS.templates(workspaceId), function () {
    return fetchSmsTemplates(workspaceId);
  }, {
    enabled: Boolean(workspaceId) && enabled,
    staleTime: 0
  });
}